import React, { useRef } from 'react';
import { Formik, Field } from 'formik';
import useFormRutine from '../../../../../hooks/useForm';
import { InputField } from '../../../../../components/formFields/InputField';
import * as Yup from 'yup';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';

const dropdownFeed: any[] = [
  { title: 'Ano', id: true },
  { title: 'Ne', id: false },
];

interface BuildingModelFormProps {
  formProps?: any;
  submitOutside: any;
  submit: (id: any, values: any) => void;
  error?: any;
  reset?: boolean;
  resetConfirm?: any;
}

const BuildingModelForm = ({
  formProps,
  submitOutside,
  submit,
  error,
  reset = false,
  resetConfirm,
}: BuildingModelFormProps) => {
  const formRef = useRef();

  useFormRutine(formRef, submitOutside, reset, formProps, resetConfirm, error);

  const init = ({ title, is_active }: any = {}) => ({
    is_active,
    title,
  });

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Povinné pole'),
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit(formProps?.id, values);
        }}
      >
        {(props) => {
          const { values } = props;

          return (
            <div className="space-y-1">
              <Field
                name="title"
                value={values.title}
                placeholder="Název"
                component={InputField}
                label="Název"
                data-testid="building-model-form-title-input"
              />

              {formProps && (
                <SelectFormField
                  name="is_active"
                  placeholder=""
                  data={dropdownFeed}
                  label="Aktivní"
                  data-testid="building-model-form-active-select"
                />
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default BuildingModelForm;
